import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  manualStockMovement: "/manual-stock-movement",
};

export const createManualStockMovement = createAsyncThunk(
  "stock/createManualStockMovement",
  async (
    data: {
      type: string;
      reason: string;
      quantity: number;
      product_slug: string;
    },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.post(
        `/manual-stock-movement/${data.product_slug}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao registrar movimentação.",
        });
      }
    }
  },
);

export const fetchManualStockMovements = createAsyncThunk(
  "stock/fetchManualStockMovements",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.manualStockMovement, {
        params,
      });
      //return response.data;
      return {
        manualStockMovement: response.data.data.manualStockMovement,
        stats: response.data.data.stats,
      };
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao buscar movimentações.",
        });
      }
    }
  },
);
